import { axios } from './index'

export const listSyncJobs = async (company?: string) => {
  const res = await axios.get('/sync-job', { params: { company } })
  return res.data.jobs
}

export const getSessionResults = async (sessionId: string) => {
  const res = await axios.get(`/sync-job/${sessionId}/results`)
  return res.data.results
}

export const downloadSessionResults = async (sessionId: string) => {
  const res = await axios.get(`/sync-job/${sessionId}/download`, {
    responseType: 'blob'
  })
  return res.data as Blob
}
